import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import { Easing } from '@tweenjs/tween.js';
import { delay } from '../../../Utility/Task/TaskQueue';
import Scene from '../../../Scene/Scene';
import { StartAudio } from '../../Audio/AudioHelper';
import { AUDIO_UI_SCORE_BEATEN } from '../../Audio';
import { AudioTrackType } from '../../Audio/AudioClip';

interface IScoreBeatenData {
    scene: Scene;
    loser: GameObject;
    winner: GameObject;
}

export class ScoreBeaten extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: IScoreBeatenData
    ): IterableIterator<number> {
        const winnerElement = meta.winner.getComponent(ElementComponent);
        const loserElement = meta.loser.getComponent(ElementComponent);

        const winnerTween = this.getTween(winnerElement);
        const loserTween = this.getTween(loserElement);

        winnerTween
            .to({ anchorY1: 0, anchorY2: 0 }, 300)
            .easing(Easing.Quadratic.InOut);

        StartAudio(meta.scene, AUDIO_UI_SCORE_BEATEN, AudioTrackType.SFX);

        yield* this.startTween(winnerTween);

        yield* delay(100);

        winnerTween
            .to({ anchorY1: 0.38, anchorY2: 0.38 }, 300)
            .easing(Easing.Back.Out)
            .start(this.elapsedTime);

        yield* delay(50);

        loserTween
            .to({ anchorY1: 0.62, anchorY2: 0.62 }, 100)
            .easing(Easing.Quadratic.InOut);

        yield* this.startTween(loserTween);

        yield* delay(150);
    }
}
